export const getPagination = (currentPage, totalPages) => {
    if (totalPages === 1) {
        return [1];
    }
    const boundaryCount = 1;
    const siblingCount = 2;
    const siblingsStart = Math.max(Math.min(
    // Natural start
    currentPage - siblingCount, 
    // Lower boundary when currentPage is high
    totalPages - boundaryCount - siblingCount * 2 - 1), 
    // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(
    // Natural end
    currentPage + siblingCount, 
    // Upper boundary when currentPage is low
    boundaryCount + siblingCount * 2 + 2), 
    // Less than endPages
    totalPages - 2);
    const startEllipsis = siblingsStart > boundaryCount + 2
        ? ['...']
        : boundaryCount + 1 < totalPages - boundaryCount
            ? [boundaryCount + 1]
            : [];
    const endEllipsis = siblingsEnd < totalPages - boundaryCount - 1
        ? ['...']
        : totalPages - boundaryCount > boundaryCount
            ? [totalPages - boundaryCount]
            : [];
    // Basic list of items to render
    // e.g. itemList = [1, '...', 4, 5, 6, '...', 10]
    return [
        1,
        ...startEllipsis,
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        ...endEllipsis,
        totalPages,
    ];
};
/**
 * Create an array filled with number
 * @example
 * range(8, 13) = [8, 9, 10, 11, 12, 13]
 */
const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
};
